var indexOf = [].indexOf;

import humanize from 'helpers/humanize';

import random from 'helpers/random';

import featureNames from 'constants/feature_names';

angular.module('gym.components').directive('sequenceReportBuilder', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/sequenceReportBuilder.html.slim'),
    scope: {
      sequence: '=',
      step: '=',
      reports: '=',
      skip: '='
    },
    controller: ["$scope", "$filter", "$modal", "SequenceService", function($scope, $filter, $modal, SequenceService) {
      var getFilterType, hasEnrolmentLimitSequenceCondition, isConditionExists, linkedReportConditionType, nonScopedSections, relativeDateReady, reportConditionType, scopedReportConditionType, userValueReady;
      $scope.relativeDateId = random();
      $scope.availableColumnOptions = {};
      $scope.featureNames = featureNames;
      nonScopedSections = _.keys($scope.sequence.sequence_object_report_options.contact);
      linkedReportConditionType = $scope.skip ? 'LinkedReportSkipSequenceCondition' : 'LinkedReportSequenceCondition';
      reportConditionType = $scope.skip ? 'ReportSkipSequenceCondition' : 'ReportSequenceCondition';
      scopedReportConditionType = $scope.skip ? 'ScopedReportSkipSequenceCondition' : 'ScopedReportSequenceCondition';
      $scope.params = {
        type: linkedReportConditionType,
        exclude_from_report: false
      };
      $scope.excludeFromReportOptions = [[false, 'is in'], [true, 'is not in']];
      $scope.periods = ['days', 'weeks', 'months', 'years'];
      $scope.multipliers = ['from_now', 'ago'];
      $scope.$watch('sequence.trigger', function(trigger) {
        $scope.availableColumnOptions = {};
        if ($scope.sequence.sequence_object_map[trigger]) {
          $scope.sequence.sequence_object_map[trigger].forEach(function(item) {
            return angular.extend($scope.availableColumnOptions, $scope.sequence.sequence_object_report_options[item]);
          });
        }
        $scope.sectionOptions = _.chain($scope.availableColumnOptions).keys().sortBy(function(item) {
          return $scope.sequence.report_columns_options_keys.indexOf(item);
        }).map(function(value) {
          return {
            value: value,
            label: $scope.sequence.column_section_name_map[value] || humanize(value)
          };
        }).value();
        if (!$scope.sectionOptions.find(function(option) {
          var ref;
          return option.value === ((ref = $scope.filter) != null ? ref.section : void 0);
        })) {
          return $scope.filter = {};
        }
      });
      $scope.requireUserValue = function() {
        var blankValueConditions, ref, ref1, ref2;
        blankValueConditions = ['Is blank', 'Is not blank'];
        return ref = (ref1 = $scope.filter) != null ? (ref2 = ref1.condition) != null ? ref2[0] : void 0 : void 0, indexOf.call(blankValueConditions, ref) < 0;
      };
      isConditionExists = function(type) {
        if (type === reportConditionType) {
          return SequenceService.isConditionTypeExists($scope.step, reportConditionType);
        } else {
          return SequenceService.isConditionTypeExists($scope.step, scopedReportConditionType);
        }
      };
      $scope.add = function() {
        var filter, type;
        filter = $scope.getReportFilter($scope.filter);
        type = getFilterType();
        if (isConditionExists(type)) {
          SequenceService.addReportFilter($scope.step, filter, type);
        } else {
          SequenceService.addReportCondition($scope.step, filter, type);
        }
        return $scope.cancel();
      };
      $scope.cancel = function() {
        if ($scope.skip) {
          $scope.step.isSkipConditionCreating = false;
        } else {
          $scope.step.isRunConditionCreating = false;
        }
        return $scope.filter = {};
      };
      $scope.onSectionChange = function() {
        return $scope.filter.column = '';
      };
      $scope.onColumnChanged = function() {
        $scope.filter.condition = '';
        return $scope.filter.relative_date = false;
      };
      $scope.onConditionChanged = function() {
        $scope.filter.user_value = '';
        $scope.filter.number = '';
        $scope.filter.relative_date = false;
        $scope.filter.multiplier = '';
        return $scope.filter.period = '';
      };
      $scope.onRelativeChange = function() {
        var base, base1;
        if ($scope.filter.relative_date) {
          $scope.filter.user_value = '';
          (base = $scope.filter).relative_date || (base.relative_date = false);
          (base1 = $scope.filter).multiplier || (base1.multiplier = $scope.multipliers[0]);
          return $scope.filter.period = 'months';
        }
      };
      relativeDateReady = function() {
        var filter;
        filter = $scope.filter;
        return ($filter('filterInt')(filter.number) >= 0) && filter.period && filter.multiplier;
      };
      userValueReady = function() {
        var ref;
        return !$scope.requireUserValue() || ((ref = $scope.filter.user_value) != null ? ref.toString() : void 0) || relativeDateReady();
      };
      $scope.isFilterValid = function() {
        var ref;
        return ((ref = $scope.filter) != null ? ref.column : void 0) && $scope.filter.condition && userValueReady();
      };
      $scope.appliedLinkedReport = function() {
        var condition;
        condition = {
          type: linkedReportConditionType
        };
        return _.findWhere($scope.step.sequence_conditions_attributes, condition);
      };
      $scope.linkReport = function() {
        return $scope.step.sequence_conditions_attributes.push($scope.params);
      };
      $scope.getReportFilter = function(filter) {
        return {
          data_type: filter.column.data_type,
          database_value: filter.column.table_and_column || filter.column.unique_id,
          database_value_label: filter.column.label,
          multiplier: filter.multiplier,
          operator: filter.condition[1],
          operator_label: filter.condition[0],
          period: filter.period,
          relative_date: filter.relative_date,
          user_value: filter.user_value,
          number: filter.number
        };
      };
      hasEnrolmentLimitSequenceCondition = function() {
        return SequenceService.isEnrolmentLimitSequenceConditionExists($scope.step);
      };
      $scope.enrolmentLimitSequenceConditionAvailable = function() {
        var apparentPosition, ref;
        apparentPosition = SequenceService.apparentPosition($scope.step, $scope.sequence);
        return apparentPosition === 1 && (ref = $scope.sequence.trigger, indexOf.call($scope.sequence.enrolment_limit_triggers, ref) >= 0) && !hasEnrolmentLimitSequenceCondition() && !$scope.skip;
      };
      getFilterType = function() {
        if (_.contains(nonScopedSections, $scope.filter.section)) {
          return reportConditionType;
        } else {
          return scopedReportConditionType;
        }
      };
      return $scope.addEnrolmentLimitSequenceCondition = function() {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/components/sequences/add_enrolment_limit_sequence_condition_modal.html.slim'),
          controller: 'AddEnrolmentLimitSequenceConditionCtrl'
        });
        return modalInstance.result.then(function(result) {
          var condition, currentConditionIndex;
          if (!result.enable_limit_count) {
            return;
          }
          condition = {
            type: 'EnrolmentLimitSequenceCondition',
            limit_count: result.limit_count
          };
          if (result.enable_time_period) {
            condition.limit_term_number = result.limit_term_number;
            condition.limit_term_unit = result.limit_term_unit;
          } else {
            condition.limit_term_number = null;
          }
          condition.limit_to_current_month = result.limit_to_current_month;
          currentConditionIndex = _.findIndex($scope.step.sequence_conditions_attributes, function(condition) {
            return condition.type === 'EnrolmentLimitSequenceCondition';
          });
          if (currentConditionIndex >= 0) {
            condition.id = $scope.step.sequence_conditions_attributes[currentConditionIndex].id;
            return $scope.step.sequence_conditions_attributes[currentConditionIndex] = condition;
          } else {
            return $scope.step.sequence_conditions_attributes.push(condition);
          }
        });
      };
    }]
  };
});
